export default function getNeutralPaletteAsRawColors(isDarkTheme: boolean) {
    return require(`../resources/neutral.color.variables.${isDarkTheme ? 'dark' : 'base'}.json`);
}
